export class InternalJobConfiguration {
  internalPostedDate: Date;
  convertToExternalDate: Date;
}

export class VisibilityConfiguration {
  constructor(public type: VisibilityTypes, public internalJobBoardIds: Array<number> = []) {}
}

export enum VisibilityTypes {
  External = 'External',
  Internal = 'Internal',
  All = 'Internal'
}

export class FacetResult {
  count: number;
  from: object;
  to: object;
  value: object;
  displayValue: string;
  isSelected: boolean;
}

export class Facet {
  isExpanded: boolean;
  name: string;
  results: Array<FacetResult>;
}

export class JobListModel {
  id: number;
  title: string;
  departmentId: number;
  departmentName: string;
  facets: Array<Facet>;
  locationCityProvince: string;
  locationId: number;
  postedDate: Date;
  autoRefresh1PostedDate: Date;
  autoRefresh2PostedDate: Date;
  isInternal: boolean;
  internalJobConfiguration: InternalJobConfiguration;

  get displayPostedDate() {
    const now = new Date();
    if (this.autoRefresh2PostedDate && new Date(this.autoRefresh2PostedDate) < now) {
      return new Date(this.autoRefresh2PostedDate);
    } else if (this.autoRefresh1PostedDate && new Date(this.autoRefresh1PostedDate) < now) {
      return new Date(this.autoRefresh1PostedDate);
    } else {
      if (!this.isInternal) {
        return this.postedDate;
      } else {
        return this.internalJobConfiguration.internalPostedDate;
      }
    }
  }
}
